// Restore microphone subscriptions after an RTC reconnect without subscribing to unwatched streams.
export function recoverCallMicrophones(participants:Iterable<any>,microphoneSource:any,attach:(track:any,participant:any)=>void,apply:(participant:any)=>void){
 for(const p of participants){
  for(const pub of p.audioTrackPublications.values()){
   if(pub.source!==microphoneSource)continue;
   if(pub.isSubscribed===false)pub.setSubscribed(true);
   if(pub.track&&!pub.isMuted&&pub.track.mediaStreamTrack?.readyState!=='ended')attach(pub.track,p);
  }
  apply(p);
 }
}
export function syncCallAudioMute(root:ParentNode,deafened:boolean){for(const el of root.querySelectorAll<HTMLAudioElement>('audio[data-participant]'))el.muted=deafened;}
